import { Divider, Stack, Typography } from '@mui/material';
import { GetLightInvoicesResponse } from '@vy/api-definition';
import { formatPrice } from '@vy/services';
import { DEFAULT_CURRENCY } from '@vy/types';
import { isNotNullOrUndefined, ItemOf } from '@vy/utils';
import { formatDate } from '../../../../../../utils/date';
import { InvoiceBillingStatusLabel } from '../../../../InvoicesPage/invoices-page-components/InvoiceBillingStatusLabel';

type InvoiceActivitySummaryProps = {
  invoice: ItemOf<GetLightInvoicesResponse['invoices']>;
};
export const InvoiceActivitySummary: React.FC<InvoiceActivitySummaryProps> = ({ invoice }) => {
  const invoiceDetails = getInvoiceDetails(invoice);

  return (
    <Stack
      sx={{
        height: 194,
        flexShrink: 0,
        padding: '24px',
        background: '#F5F6FA',
      }}
    >
      <Stack sx={{
        gap: 0.5
      }}>
        <Stack
          direction="row"
          sx={{
            justifyContent: "space-between",
            alignItems: "center"
          }}>
          <Typography
            sx={{
              fontSize: 16,
              lineHeight: "24px",
              color: "#020F20"
            }}>
            Amount due
          </Typography>

          <InvoiceBillingStatusLabel billingStatus={invoice.billingStatus} />
        </Stack>
        <Typography
          sx={{
            fontSize: 36,
            color: "#020F20",
            width: 217,
            height: 48,
            lineHeight: "48px"
          }}>
          {formatPrice(invoice.revenueBreakdown.total, DEFAULT_CURRENCY)}
        </Typography>
      </Stack>
      <Divider
        sx={{
          width: 268,
          borderColor: '#5F6978',
          marginTop: '16px',
          marginBottom: '16px',
          borderStyle: 'dashed',
        }}
      />
      <Stack direction="row">
        {invoiceDetails.map(({ label, value }) => (
          <Stack key={`${label}-${value}`} spacing="2px" sx={{
            width: 104
          }}>
            <Typography
              sx={{
                lineHeight: "20px",
                color: "#7E8796",
                fontSize: 14
              }}>
              {label}
            </Typography>
            <Typography
              sx={{
                lineHeight: "20px",
                color: "#020F20",
                fontSize: 14
              }}>
              {value}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};

function getInvoiceDetails(invoice: ItemOf<GetLightInvoicesResponse['invoices']>) {
  return [
    { label: 'Issue date', value: getIssueDate(invoice) },
    { label: 'Due date', value: isNotNullOrUndefined(invoice.dueDate) ? formatDate(invoice.dueDate) : '--' },
    { label: 'Ref no.', value: invoice.ref },
  ];
}

function getIssueDate(invoice: ItemOf<GetLightInvoicesResponse['invoices']>) {
  if (isNotNullOrUndefined(invoice.issuedAt)) {
    return formatDate(invoice.issuedAt);
  }

  return isNotNullOrUndefined(invoice.invoicingDate) ? formatDate(invoice.invoicingDate) : '--';
}
